export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/20e765fe22790b7f1075e229233d4cab.svg";